import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import styles from './EditStaffCardPage.module.css'
import Navbar from '../../components/Navbar/Navbar'
import IconTrashRed from '../../assets/icons/IconTrashRed.svg'
import HeaderForCard from '../../components/HeaderForCard/HeaderForCard'
import EditStaffMainInformation from '../../components/EditStaffMainInformation/EditStaffMainInformation'
import CustomModal from '../../components/UI/CustomModal/CustomModal'
import DeleteComponent from '../../components/DeleteComponent/DeleteComponent'
import { useAppDispatch, useAppSelector } from '../../redux/types/types'
import { deleteStaff, getCurrentStaff } from '../../redux/actions/staffAction'
import Loader from '../../components/UI/Loader/Loader'
import PATH from '../../navigation/path'
import CustomButton from '../../components/UI/CustomButton/CustomButton'
import { useToast } from '../../context/ToastContext'

const EditStaffCardPage = () => {
  const [visible, setVisible] = useState<boolean>(false)
  const { companyId } = useParams<{ companyId: string }>()
  const { workerId } = useParams<{ workerId: string }>()
  const { showSuccess, showError } = useToast()
  const { token, user } = useAppSelector((state) => state.auth)

  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const { currentStaff, isLoading } = useAppSelector((state) => state.staff)

  const onDeletePopup = () => {
    setVisible(true)
  }

  const onDeleteStaff = async () => {
    const resultAction = await dispatch(deleteStaff({ staffId: String(currentStaff.id), token }))

    if (deleteStaff.rejected.match(resultAction)) {
      showError('Произошла ошибка при удалении сотрудника')
    } else {
      navigate(`${PATH.companyManagementStaffPage}${companyId}`)
      showSuccess('Сотрудник успешно удален')
    }
  }

  useEffect(() => {
    dispatch(getCurrentStaff({ staffId: workerId, token }))
  }, [companyId, workerId, dispatch])

  if (isLoading) {
    return <Loader />
  }

  return (
    <div className={styles.editCompanyStaffCardPage}>
      <CustomModal visible={visible} setVisible={setVisible}>
        <DeleteComponent
          title='Удаление сотрудника'
          description='Хотите удалить данного сотрудника?'
          onCancelHandler={() => setVisible(false)}
          onDeleteHandler={onDeleteStaff}
        />
      </CustomModal>
      <Navbar />
      <HeaderForCard
        deleteButton={
          user.employee.id != currentStaff.id ? (
            <CustomButton
              iconSrc={IconTrashRed}
              className={styles.deleteBtn}
              title={'Удалить сотрудника'}
              onClick={onDeletePopup}
            />
          ) : (
            <></>
          )
        }
        title='Карточка сотрудника'
      />
      <div className={styles.content}>
        <EditStaffMainInformation staffData={currentStaff} />
      </div>
    </div>
  )
}

export default EditStaffCardPage
